/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowRightToArc = createReactComponent(
  "arrow-right-to-arc",
  "IconArrowRightToArc",
  [
    ["path", { d: "M3 12h12", key: "svg-0" }],
    ["path", { d: "M11 8l4 4l-4 4", key: "svg-1" }],
    ["path", { d: "M12 21a9 9 0 0 0 0 -18", key: "svg-2" }]
  ]
);

export { IconArrowRightToArc as default };
//# sourceMappingURL=IconArrowRightToArc.js.map
